export const coachCommissionTableKeys = {
    all: ['coachCommissionTable'] as const,
    list: (centerId: string, year: string, month: string) =>
        [...coachCommissionTableKeys.all, 'list', centerId, year, month] as const,
};
